import TipsCarousel from "./TipsCarousel";

export default function Tips () {
    return (
        <section className="section">
            <div className="sectionHeader">
                <h1 className="sectionTitle">Tips from our team</h1>
            </div>
            <TipsCarousel />
        </section>
    );
}
